import { render, staticRenderFns } from "./shared-paper-list.html?vue&type=template&id=43b714ae&scoped=true&external"
import script from "./shared-paper-list.js?vue&type=script&lang=js&external"
export * from "./shared-paper-list.js?vue&type=script&lang=js&external"
import style0 from "./shared-paper-list.scss?vue&type=style&index=0&id=43b714ae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b714ae",
  null
  
)

export default component.exports